module.exports = __webpack_public_path__ + "fonts/3954.c560a8ec.woff";